<lib-modal
  [closeLabel]="'general.close' | translate"
  [visible]="visible"
  [title]="'changeRoleDialog.title' | translate"
  [contentTemplate]="resolvedTemplate ?? undefined"
  [saveText]="'changeRoleDialog.save' | translate"
  [cancelText]="'changeRoleDialog.cancel' | translate"
  [disabled]="saveDisabled || busy"
  (save)="onSave()"
  (cancel)="onCancel()"
  (visibleChange)="visibleChange.emit($event)"
></lib-modal>

<ng-template #roleContent>
  <mat-form-field appearance="fill" class="change-role-dialog__field">
    <mat-label>{{ 'changeRoleDialog.roleLabel' | translate }}</mat-label>
    <mat-select [formControl]="roleControl">
      @for (role of roles; track role.id) {
        <mat-option [value]="role.id">{{ 'roles.' + role.code | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-template>
